/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Food({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.026.342a.5.5 0 0 1 .556-.335C11.81 1.045 16 6.242 16 11.5a.5.5 0 0 1-.371.483l-15 4a.5.5 0 0 1-.603-.641l5-15Zm.81.728L1.269 14.778l13.724-3.66c-.193-4.5-3.77-8.96-9.155-10.048Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M9.49 5.925a11.42 11.42 0 0 0-4.876-2.671l.252-.968a12.42 12.42 0 0 1 8.607 7.971l-.946.326A11.42 11.42 0 0 0 9.49 5.925ZM9.244 10.017a2 2 0 0 0-1.748 3.303l-.752.66A3 3 0 1 1 12 12h-.5.5c0 .221-.024.442-.072.659l-.976-.218a2 2 0 0 0-1.708-2.424Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M4.88 5.343a2 2 0 0 0-.786-1.016l.552-.834A3 3 0 0 1 2.81 8.99l.06-.998a2 2 0 0 0 2.01-2.648ZM3.414 12.836A2 2 0 0 0 2 12.25v-1a3 3 0 0 1 3 3H4a2 2 0 0 0-.586-1.414Z" clipRule="evenodd" /></svg>;
}
;